import type { AutocompleteUser } from 'models';
import { Trans } from 'react-i18next';
import { Col, Flex, ProfileCard, Row } from 'ui';
import { IconDirectMessageButton } from 'features/chat';
import { Paragraph } from 'ui/typography';

type P = {
  administrators: AutocompleteUser[];
};

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const ProgramAdmins = ({ administrators }: P) => (
  <Flex className="card-wrapper card-wrapper--program-author" vertical>
    <Paragraph className="card-content__title">
      <Trans>Admins</Trans>
    </Paragraph>
    <Row gutter={12}>
      {administrators.map((administrator) => (
        <Col className="program-admins__item" key={administrator.id} span={8}>
          <ProfileCard cardAction={<IconDirectMessageButton legacyUserId={administrator.id} />} user={administrator} />
        </Col>
      ))}
    </Row>
  </Flex>
);

export default ProgramAdmins;
